import { Link } from 'react-router-dom';
import './ProjectsSection.css';
import img_one from './images/1.png';import img_two from './images/2.png';
import img_three from './images/3.png';import img_four from './images/4.png';
import img_five from './images/5.png'; import img_six from './images/6.png';

import bike1 from './images/bike1.jpg';
import bike2 from './images/bike2.jpg';

import billy from './images/billy1.jpg';
import b2 from './images/billy2.jpg';
import b3 from './images/billy3.jpg';
import b4 from './images/billy4.jpg';
import b5 from './images/billy5.jpg';
import b6 from './images/billy6.jpg';

import o1 from './images/o1.jpg';
import o2 from './images/o2.jpg';

import s1 from './images/ss1.jpg';
import s2 from './images/ss2.jpg';
import s3 from './images/ss3.jpg';
import s4 from './images/ss4.jpg';
import s5 from './images/ss5.jpg';

import web_one from './images/web2.jpg';
import web_two from './images/web3.jpg';

export default function ProjectSection(){
    return(
        <div className="ProjectSection project_section_parent_wrapper container-fluid py-4">
            <div className="container project_section_child_wrapper py-4">
                <h4 className="project_heading font-weight-bold">
                    My Projects
                </h4>
                <h5 className="project_sub_heading">
                    Design Projects
                </h5>
                <p className="project_description2">
                    More Designs &nbsp; 
                    : NB: I am Also a primary intern multimedia designer at A2Z Tech Solutions 
                    helped grow the Linkedin account from 200 followers to 1000 followers 
                    in a period of 8 months
                </p>
                <p>
                    <button
                     className="btn-sm btn bg-danger text-white py-2 px-3">
                        <Link className='text-white' to="https://momentumportfolio.netlify.app/">
                            Momentum Limited  Demo Designs
                        </Link>
                    </button> &nbsp;
                    <button
                     className="btn-sm btn bg-primary text-white py-2 px-3">
                        <Link className='text-white' to="https://faithseasonsdesign.github.io/presentation/">
                            View Other design work
                        </Link>
                    </button> 
                </p>
                
                <div className="row g-2 project_row mt-5">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <img src={img_one} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <img src={img_two} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <img src={img_three} alt="" className="img-fluid mx-auto" />
                    </div>
                </div>
                <div className="row gy-2 project_row mt-5">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <img src={img_four} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <img src={img_five} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <img src={img_six} alt="" className="img-fluid mx-auto" />
                    </div>
                </div>
                <div className="row g-2 mt-3">
                    <div className="col-12">
                        <h6 className="project_sub_heading">
                            Stuff I did for momentum as a cover letter
                        </h6>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={billy} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={b2} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={bike1} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={bike2} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={b3} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={b4} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={s1} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={s2} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={s3} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={s4} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={s1} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={s2} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={o1} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={o2} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={b5} alt="" className="img-fluid mx-auto" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                        <img src={b6} alt="" className="img-fluid mx-auto" />
                    </div>
                </div>
            </div>
        </div>
    );
}